import React, { useRef, createRef, useEffect } from 'react';
import styled from 'styled-components';
// import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Typo } from 'tmt-ui-kit';

import { actions as galleryActions } from '~/redux/reducers/gallery';

import { path } from '~/utils/media';
import { GalleryName } from '~/utils/gallery';

const Container = styled.div`
  display: flex;
  margin-top: 8px;
  ${props => (props.spaceBetween && 'justify-content: space-between;')}
  width: 408px;
  @media (max-width: 425px) {
    width: 352px;
  }
  @media (max-width: 375px) {
    width: 100%;
  }
`;
const GalleryCard = styled.div`
  display: ${props => (props.isHide ? 'none' : 'block')};
  ${props => (props.useMargin && 'margin-right: 8px;')}
  user-select: none;
  cursor: pointer;
  border-radius: 6px;
  overflow: hidden;
  position: relative;
  width: 128px;
  height: 128px;
  background: linear-gradient(118deg,#f6f9fb,#e2ebef);
  background: ${props => (props.bg ? `url(${props.bg})` : 'linear-gradient(118deg,#f6f9fb,#e2ebef)')};
  background-size: cover;

  @media (max-width: 425px) {
      width: 112px;
      height: 112px;
  }

  @media (max-width: 320px) {
      width: 90px;
      height: 90px;
  }
`;

const MoreCountText = styled(Typo.Medium)`
  font-size: 30px !important;
  color: ${props => props.theme.white} !important;
`;

const BlackOpacity = styled.div`
  position: absolute;
  display: ${props => (props.isHide ? 'none' : 'flex')};
  align-items: center;
  justify-content: center;
  border-radius: 6px;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
`;

const enhance = connect(
  null,
  {
    openAndGoTo: galleryActions.openAndGoTo,
  }
);

const GalleryReview = (props) => {
  const { images, openAndGoTo, defaultAlt } = props;
  const imageRef = useRef(images.map(() => createRef()));

  useEffect(() => {
    const observer = new window.IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting && entry.target) {
          const dom = entry.target;
          dom.style.backgroundImage = `url(${dom.dataset.img})`;
          observer.unobserve(entry.target);
        }
      });
    });
    if (imageRef.current) {
      imageRef.current.forEach(t => t.current && observer.observe(t.current));
    }
  }, []);

  return (
    <Container spaceBetween={images.length !== 2}>
      {images.slice(0, 3).map((img, index) => (
        <GalleryCard
          ref={imageRef.current[index]}
          key={img}
          data-img={path(img, 'thumbnail')}
          isHide={index > 2}
          onClick={() => openAndGoTo(index, GalleryName.LOCAL_TABLE, { images: images.map(imagePath => ({ image: imagePath, caption: '' })), defaultAlt })}
          useMargin={images.length === 2}
        >
          {(index === 2 && images.length > 3) && (
            <BlackOpacity>
              <MoreCountText>
                +{images.length - 3}
              </MoreCountText>
            </BlackOpacity>
          )}
        </GalleryCard>
      ))}
    </Container>
  );
};

// class GalleryReview extends Component {
//   static propTypes = {
//     images: PropTypes.array,
//     openAndGoTo: PropTypes.func,
//     defaultAlt: PropTypes.string
//   }

//   thumbnail = [];

//   componentDidMount() {
//     this.observer = new window.IntersectionObserver((entries) => {
//       // const entry = entries[0];
//       entries.forEach(entry => {
//         if (entry.isIntersecting && entry.target) {
//           // if (!this.isSeenDOM) {
//           //   this.isSeenDOM = true;
//           const dom = entry.target;
//           dom.style.backgroundImage = `url(${dom.dataset.img})`;
//           this.observer.unobserve(entry.target);
//           // this.container.style.backgroundImage = `url('${config.assetPath}/static/images/lx-photo@2x.png')`;
//           // }
//         }
//       });
//     }, { threshold: [0.2] });
//     setTimeout(() => {
//       if (this.thumbnail) {
//         this.thumbnail.forEach(t => this.observer.observe(t));
//       }
//     }, 100);
//   }

//   render() {
//     const { images, openAndGoTo, defaultAlt } = this.props;
//     return (
//       <Container spaceBetween={images.length !== 2}>
//         {images.slice(0, 3).map((img, index) => (
//           <GalleryCard
//             ref={c => { this.thumbnail[index] = c; }}
//             key={img}
//             data-img={path(img, 'thumbnail')}
//             isHide={index > 2}
//             onClick={() => openAndGoTo(index, GalleryName.LOCAL_TABLE, { images: images.map(imagePath => ({ image: imagePath, caption: '' })), defaultAlt })}
//             useMargin={images.length === 2}
//           >
//             {(index === 2 && images.length > 3) && (
//               <BlackOpacity>
//                 <MoreCountText>
//                   +{images.length - 3}
//                 </MoreCountText>
//               </BlackOpacity>
//             )}
//           </GalleryCard>
//         ))}
//       </Container>
//     );
//   }
// }

export default enhance(GalleryReview);
